const productTypeConfig = {
  hotel: 1,
  flight: 5,
  flight_wf: 51,
  train: 6,
  car: 7,
  takeout: 10,
  mall: 20,
};

module.exports = {
  productTypeConfig,
};
